import { Divider } from '@chakra-ui/react'
import React from 'react'

const Footer = () => {
  return (
    <div>
        <Divider />

        <p className='text-center text-zinc-500 p-4 mt-5'>&copy; 2026 Carl Katalbas. All rights reserved.</p>
    </div>
  )
}

export default Footer